import React from 'react';
import {
  Nav,
  Navbar,
  NavDropdown,
} from 'react-bootstrap';
import ModalNotificaciones from '../widgets/alerts/ModalNotificaciones';
import '../widgets/alerts/ModalNotificaciones.css';

function HeaderMenu({ children }) {
  const empresa = sessionStorage.getItem('nombre');
  const nombre_usuario = sessionStorage.getItem('usuario');
  const company = sessionStorage.getItem('company');
  const isHome = typeof window !== 'undefined' && (window.location.pathname === '/home' || window.location.pathname === '/home/');

  return (
    <React.Fragment>
      <Navbar expand="sm">
        {/* Logo a la izquierda */}
        <Navbar.Brand href="/home">
          <img
            alt="Logo"
            src="/logopage.png"  // Reemplaza con la ruta de tu logo
            width="150"
            height="50"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            {children}
          </Nav>
          {company === "111111111" &&
            <NavDropdown title="MENU GTIC" id="collasible-nav-dropdown">
              <NavDropdown.Item href="/reporteempresas">Reporte Estado Facturacion</NavDropdown.Item>
              <NavDropdown.Item href="/reportenomina">Reporte Estado Nomina</NavDropdown.Item>
              <NavDropdown.Item href="/companyblock">Administrar Empresas</NavDropdown.Item>
              <NavDropdown.Item href="/reporteconsumo">Reporte Consumo</NavDropdown.Item>
              <NavDropdown.Item href="/manage_doc">Administracion Documentos</NavDropdown.Item>
              <NavDropdown.Item href="/manage_doc_payroll">Administracion Documentos Nomina</NavDropdown.Item>
              <NavDropdown.Item href="/auditoria_ingresos">Auditoría de Ingresos</NavDropdown.Item>
              <NavDropdown.Item href="/portal_clientes">Ingreso de Clientes</NavDropdown.Item>
            </NavDropdown>
          }
          {/* Botón de cerrar sesión y centro de avisos a la derecha */}
          <Nav className="ml-auto" style={{ display: 'flex', alignItems: 'center' }}>
            {isHome && <ModalNotificaciones />}
            <Nav.Link>{nombre_usuario}</Nav.Link>
            <Nav.Link>{empresa}</Nav.Link>
            <a href="/cerrarsesion" className="header-btn-logout">
              Cerrar Sesión
            </a>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </React.Fragment>
  );
}

export default HeaderMenu;


// WEBPACK FOOTER //
// ./src/components/menu/header_container.jsx